import React from "react";

export const PageHeader = ({ t }) => {
  return (
    <div className="kt-subheader kt-grid__item" id="kt_subheader">
      <div className="kt-container kt-container--fluid">
        <div className="kt-subheader__main">
          <h3 className="kt-subheader__title">{t("Paramètre")}</h3>
          <span className="kt-subheader__separator kt-hidden" />
          <div className="kt-subheader__breadcrumbs">
            <a href="#link" className="kt-subheader__breadcrumbs-home">
              <i className="flaticon2-shelter" />
            </a>
            <span className="kt-subheader__breadcrumbs-separator" />
            <a href="#link" className="kt-subheader__breadcrumbs-link">
              {t("Limitation de rejet")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
